// Shared left-nav rail item for the content-creation dialogs (Playlist,
// Layout, Mix) — one visual language for "here are this dialog's sections,
// pick one" instead of each dialog hand-rolling its own tab button.
export function NavItem({
  active, onClick, icon: Icon, label, count, dot,
}: {
  active: boolean
  onClick: () => void
  icon: React.ComponentType<{ className?: string }>
  label: string
  // A running item count (e.g. Content's selected-item total) or a small
  // "added" dot (e.g. a single companion pick) — a tab shows at most one.
  count?: number
  dot?: boolean
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-start transition-colors ${
        active ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-muted hover:text-foreground'
      }`}
    >
      <Icon className="w-4 h-4 shrink-0" />
      <span className="flex-1 min-w-0 truncate">{label}</span>
      {count != null && count > 0 && <span className="rounded-full bg-muted px-1.5 py-0.5 text-[10px] text-muted-foreground shrink-0">{count}</span>}
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-primary shrink-0" />}
    </button>
  )
}

// The rail's own container — fixed width, vertical stack, scrolls if a
// dialog ever has enough tabs to need it.
export function NavRail({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-44 shrink-0 border-e border-border p-2 flex flex-col gap-1 overflow-y-auto overflow-x-hidden">
      {children}
    </div>
  )
}
